import React from 'react';
export function PainSection() {
  return <section className="bg-gray-50 py-12 md:py-16 px-4" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-124">
          Si estás pasando por esto, necesito hacerte una pregunta honesta
        </h2>

        <div className="bg-white rounded-lg shadow-lg p-6 md:p-10 mb-8" data-id="element-125">
          <p className="text-lg md:text-xl text-gray-800 mb-6 font-semibold" data-id="element-126">
            ¿Te pasa que no hablaron mas y aun asi aunque haya sido alguien
            importante o no, pensas en el todo el tiempo?
          </p>

          <div className="space-y-4 text-gray-700 text-base md:text-lg" data-id="element-127">
            <p className="font-semibold" data-id="element-128">No porque seas débil.</p>
            <p className="font-semibold" data-id="element-129">No porque no tengas amor propio.</p>
            <p className="mt-6" data-id="element-130">
              Sino porque nadie te enseñó cómo cortar ese vínculo de verdad.
            </p>
          </div>
        </div>

        <div className="space-y-4 text-lg md:text-xl text-gray-800" data-id="element-131">
          <p data-id="element-132">Revisás su perfil?</p>
          <p data-id="element-133">Pensás qué estará haciendo?</p>
          <p data-id="element-134">Imaginás que vuelve a escribirte?</p>
          <p className="mt-6" data-id="element-135">
            Y aunque sabés que no es para vos seguis esperando?
          </p>
          <p className="mt-6 font-bold text-red-600" data-id="element-136">
            eso agota y desvia tu energia.
          </p>
        </div>
      </div>
    </section>;
}